import { ICategory, IHobby, ISkill, ISubject } from '@wot/typings';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import categoryApi from '../../api/categories';

export default function TopSubjects() {
  const [typeSelected, setTypeSelected] = useState<'subject' | 'hobby' | 'skill'>('subject');
  const [data, setData] = useState<ICategory<ISubject | IHobby | ISkill>[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    categoryApi.getCategoriesByType(typeSelected).then((data) => {
      setData(data);
    });
  }, [typeSelected]);

  return (
    <div className="bg-white flex flex-col md:flex-row md:justify-between container m-auto py-10">
      <div>
        <div className="flex flex-col gap-y-3">
          <span
            className={`font-medium md:text-4xl text-xl ${
              typeSelected === 'subject' ? 'text-primary' : 'text-neutralBlue1'
            } cursor-pointer`}
            onClick={() => setTypeSelected('subject')}
          >
            Top Subjects
          </span>
          <span
            className={`font-medium md:text-4xl text-xl ${
              typeSelected === 'hobby' ? 'text-primary' : 'text-neutralBlue1'
            } cursor-pointer`}
            onClick={() => setTypeSelected('hobby')}
          >
            Top Hobbies
          </span>
          <span
            className={`font-medium md:text-4xl text-xl ${
              typeSelected === 'skill' ? 'text-primary' : 'text-neutralBlue1'
            } cursor-pointer`}
            onClick={() => setTypeSelected('skill')}
          >
            Top Skill Development
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-y-8 md:mt-0 mt-6">
        <div className="grid grid-flow-row grid-cols-3 gap-x-10 gap-y-10">
          {data &&
            data.map((item, i) => (
              <span
                onClick={() =>
                  navigate('/find-tutor', { state: { categoryType: typeSelected, name: item.category.name } })
                }
                className="md:text-xl text-base font-normal text-primary cursor-pointer"
                key={i}
              >
                {item?.category?.name}
              </span>
            ))}
        </div>
      </div>
    </div>
  );
}
